import { ContainerStatus, Item, Movement, MovementDataStore, movementSelectors } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component, Watch } from 'vue-property-decorator';

import { AddContainerForm, Values } from './add-container-form';

require('./add-container-modal.scss')

@Component({
    components: {
        sAddContainerForm: AddContainerForm,
    },
    props: {
        movement: Object, 
        noCloseImmediately: Boolean, 
        canChainAdd: Boolean, 
        statusesToSearch: Array, 
        excludedIds: Array,
        excludedItemsWarningMessageKey: {
            type: String,
        },
    },
    template: require('./add-container-modal.html'),
})
export class AddContainerModal extends ReactiveVue {
    public validatedItems: Array<Item['id']>;
    public noCloseImmediately: boolean;
    public canChainAdd: boolean
    public statusesToSearch: ContainerStatus[]

    public shouldChainAdd: boolean = false

    public initialValues: Values = {
        identifier: null as any,
        location: null as any,
    };

    public mounted = false;

    public $movementDataStore: MovementDataStore;
    public $refs: {
        modal: any;
    };

    public open() {
        (this.$refs.modal as any).show();
    }

    public close() {
        (this.$refs.modal as any).hide();
    }

    public onHide() {
        this.mounted = false;
    }

    public onShow() {
        this.mounted = true;
    }

    private onContainerSelected(event) {
        this.$emit('container-selected', event)
        if (!this.noCloseImmediately && (!this.canChainAdd || !this.shouldChainAdd)) {
            this.$refs.modal.hide();
        }
    }

    @Watch('mounted')
    private onMountedChange(value) {
        this.$emit('mounted', value);
    }
}
